// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ApplicationDialog_wrapper_2Qivm","infoLabel":"ApplicationDialog_infoLabel_1j9i9","leftApplicationsLabel":"ApplicationDialog_leftApplicationsLabel_34-3G"};